import script from "./autoLoginDemo.vue?vue&type=script&setup=true&lang=ts"
export * from "./autoLoginDemo.vue?vue&type=script&setup=true&lang=ts"

import "./autoLoginDemo.vue?vue&type=style&index=0&id=1ae34a76&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae34a76"]])

export default __exports__